import * as Yup from "yup";
import { PersonStamdataAendringInteresseForm } from "../../interfaces/stamdata";

const getInteresseIds = (values: PersonStamdataAendringInteresseForm) =>
  [values.interesse1, values.interesse2, values.interesse3]
    .filter((interesse) => interesse?.id)
    .map((interesse) => interesse!.id);

export const accountInteresserValidationSchema = Yup.object({
  interesse1: Yup.mixed().nullable(),
  interesse2: Yup.mixed().nullable(),
  interesse3: Yup.mixed().nullable(),
})
  .test(
    "at-least-one",
    "Vælg mindst ét interesseområde.",
    (values) =>
      getInteresseIds(values as PersonStamdataAendringInteresseForm).length > 0,
  )
  .test(
    "unique-interesser",
    "Hvert interesseområde kan kun vælges én gang.",
    (values) => {
      const ids = getInteresseIds(
        values as PersonStamdataAendringInteresseForm,
      );
      return new Set(ids).size === ids.length;
    },
  );
